import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilterHelperService {
  private readonly specialFilterCharacters = [
    ',',
    '|',
    '<',
    '>',
    '=',
    '.',
    '\\',
  ];

  constructor() {}

  public formatFilterValue(filter: string): string {
    return this.escapeSpecialFilterCharacters(filter);
  }

  public escapeSpecialFilterCharacters(filter: string): string {
    if (filter === null || filter === undefined) return filter;
    filter = String(filter);
    let result = '';
    for (let i = 0; i < filter.length; i++) {
      const char = filter[i];
      // If char is special and not already escaped
      if (this.specialFilterCharacters.includes(char)) {
        if (i === 0 || filter[i - 1] !== '\\') {
          result += '\\';
        }
      }
      result += char;
    }
    return result;
  }
}
